import { render, staticRenderFns } from "./user-tags.vue?vue&type=template&id=21798740&lang=pug"
import script from "./user-tags.vue?vue&type=script&lang=js"
export * from "./user-tags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports